import '@babel/polyfill';
import jquery from '../libs/import-jquery';
import { SvarMap } from '../libs/svarweb';
import './kundo.js';
import { render } from 'inferno';
import { h } from 'inferno-hyperscript';
import { autorun } from 'mobx';

import { ModeSwitcherComponent } from '../libs/ModeSwitcher'; 
import { RightColumnComponent } from '../libs/DamComponent';

$(document).ready(function () {
    const map = window.map = new SvarMap();
    
    map.whenReady(function () {
        map.fitSweden();
        map.addLayer(map.lakeLayer);
    });
    
    autorun(() => {
        const mode = STATE.mode;
        const showLakeMaps = STATE.showLakeMaps;
        
        map.off('click');
        if(mode === 'lake') {
            map.forceRemoveLayer(map.damLayer);
            map.forceRemoveLayer(map.damMarkers);
            map.forceAddLayer(map.lakeLayer);
            map.forceAddLayer(map.lakePolygonLayer);
            
            if(showLakeMaps) {
                map.forceAddLayer(map.mapMarkers);
            } else {
                map.forceRemoveLayer(map.mapMarkers);
            }
            
            map.on('click', evt => {
                map.clearLakes();
                map.getLakeInfo(evt.latlng)
            });
        } else if(mode === 'dam') {
            map.forceRemoveLayer(map.lakeLayer);
            map.forceRemoveLayer(map.lakePolygonLayer);
            map.forceRemoveLayer(map.mapMarkers);
            
            map.forceAddLayer(map.damLayer);
            map.forceAddLayer(map.damMarkers);
            
            map.on('click', evt => {
                map.clearDams();
                map.getDammInfo(evt.latlng, STATE.damFilter)
            });
        }
    });
    
    autorun(() => {
        map.filterDams(STATE.damFilter);
    });
    
    render(h(ModeSwitcherComponent), document.getElementById('mode-switcher'));
    render(h(RightColumnComponent, { map: map }), document.querySelector('#sidebar'));
});
